import { render, staticRenderFns } from "./MMyCoupon.vue?vue&type=template&id=5dd975d8&"
import script from "./MMyCoupon.vue?vue&type=script&lang=js&"
export * from "./MMyCoupon.vue?vue&type=script&lang=js&"
import style0 from "./MMyCoupon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports